var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21176_34914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4502 6.95996H12.4502V16.86H14.4502V6.95996Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4498 20.3001C13.9248 20.3001 14.3098 19.915 14.3098 19.4401C14.3098 18.9651 13.9248 18.5801 13.4498 18.5801C12.9749 18.5801 12.5898 18.9651 12.5898 19.4401C12.5898 19.915 12.9749 20.3001 13.4498 20.3001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8901 23.5199H1.00007C0.823859 23.5206 0.650592 23.4747 0.497814 23.3869C0.345036 23.2991 0.21817 23.1725 0.130066 23.0199C0.0422976 22.8679 -0.00390625 22.6954 -0.00390625 22.5199C-0.00390625 22.3444 0.0422976 22.1719 0.130066 22.0199L12.5801 0.459896C12.668 0.308357 12.7941 0.18257 12.946 0.0951309C13.0978 0.00769148 13.2699 -0.0383301 13.4451 -0.0383301C13.6203 -0.0383301 13.7924 0.00769148 13.9442 0.0951309C14.096 0.18257 14.2222 0.308357 14.3101 0.459896L26.7501 22.0199C26.8378 22.1719 26.884 22.3444 26.884 22.5199C26.884 22.6954 26.8378 22.8679 26.7501 23.0199C26.6628 23.171 26.5375 23.2967 26.3867 23.3844C26.2358 23.4721 26.0646 23.5188 25.8901 23.5199ZM2.73007 21.5199H24.1501L13.4401 2.9599L2.73007 21.5199Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21176_34914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.89,
    height: 23.52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlined);
export default __webpack_public_path__ + "static/media/WarningOutlined.c0b95f90.svg";
export { ForwardRef as ReactComponent };